import {
  Button,
  Card,
  Col,
  Row,
  Space,
  Tag,
  Typography,
  message,
  theme,
} from "antd";
import EmptyTripDTO from "../../../shared/dtos/emptyTripDto";
import {
  Calendar,
  CarIcon,
  DestinationIcon,
  HashtagIcon,
  OriginIcon,
  ProviderIcon,
} from "../../../shared/constants/Images";
import { MinusSquareOutlined } from "@ant-design/icons";
import { useState } from "react";
import { deleteEmptyTripApi } from "../../../services/emptyTripApi";
import dayjs from "dayjs";
import {
  AntDesignWhite,
  IconDarkMode,
} from "../../../shared/constants/Resources";

const { Text } = Typography;

interface Props {
  emptyTrip: EmptyTripDTO | undefined;
  selected?: boolean;
  onSelected?: (e?: EmptyTripDTO) => void;
  refetch?: () => void;
}

const EmptyTripCard = ({ emptyTrip, selected, onSelected, refetch }: Props) => {
  const {
    token: { colorText },
  } = theme.useToken();
  const [deleting, setDeleting] = useState(false);

  const deleteEmptyTrip = async (e: any) => {
    e.stopPropagation();
    if (emptyTrip?.id) {
      setDeleting(true);
      try {
        await deleteEmptyTripApi(emptyTrip?.id);
        if (refetch) refetch();
        message.success("Viaje vacío eliminado satisfactoriamente.");
      } catch (error) {
        message.error(
          "Ha ocurrido un error al intentar eliminar el viaje vacío.",
        );
      }
      setDeleting(false);
    }
  };

  return (
    <div
      style={{
        margin: "5px 8px 12px 8px",
        boxShadow: selected ? "rgba(0, 0, 0, 0.80) 0px 2px 5px" : "",
      }}
    >
      <Card
        styles={{
          body: {
            padding: 0,
            background: selected
              ? colorText !== AntDesignWhite
                ? "#e5e5e5"
                : "rgb(99 99 99)"
              : "",
          },
        }}
        hoverable
        onClick={() => {
          if (onSelected) onSelected(emptyTrip);
        }}
      >
        <Row gutter={[0, 16]} style={{ padding: "20px 18px" }}>
          <Col
            span={24}
            className="info-trip-card-container custom-text-card-trip"
          >
            <Space className="booking-id">
              <img
                src={HashtagIcon}
                alt="bookingId"
                style={{
                  filter: colorText === AntDesignWhite ? IconDarkMode : "",
                }}
              />
              <Text>{emptyTrip?.bookingId}</Text>
            </Space>
          </Col>
          <Col span={24} className="info-trip-card-container">
            <div className="custom-text-card-trip" style={{ width: "100%" }}>
              <Space>
                <img
                  src={OriginIcon}
                  alt="origen"
                  style={{
                    filter: colorText === AntDesignWhite ? IconDarkMode : "",
                  }}
                />
                <Text>{emptyTrip?.originAddress}</Text>
              </Space>
            </div>
            <div className="custom-text-card-trip" style={{ width: "100%" }}>
              <Space>
                <img
                  src={DestinationIcon}
                  alt="destino"
                  style={{
                    filter: colorText === AntDesignWhite ? IconDarkMode : "",
                  }}
                />
                <Text>{emptyTrip?.destinationAddress}</Text>
              </Space>
            </div>
          </Col>
          <Col span={24}>
            <div className="custom-text-card-trip">
              <Space>
                <img
                  src={CarIcon}
                  alt="pago"
                  style={{
                    filter: colorText === AntDesignWhite ? IconDarkMode : "",
                  }}
                />
                <Text>{emptyTrip?.userRequest?.serviceType?.name}</Text>
              </Space>
            </div>
          </Col>
          <Col span={24} className="info-trip-card-container">
            <div className="custom-text-card-trip">
              <Space>
                <img
                  src={ProviderIcon}
                  alt="conductor"
                  style={{
                    filter: colorText === AntDesignWhite ? IconDarkMode : "",
                  }}
                />
                <Text>
                  {emptyTrip?.provider
                    ? `${emptyTrip?.provider?.firstName} ${emptyTrip?.provider?.lastName}`
                    : emptyTrip?.userRequest?.provider
                    ? `${emptyTrip?.userRequest?.provider?.firstName} ${emptyTrip?.userRequest?.provider?.lastName}`
                    : "No hay un conductor asignado"}
                </Text>
              </Space>
            </div>
            <div className="custom-text-card-trip">
              <Space>
                <img
                  src={Calendar}
                  alt="car"
                  style={{
                    filter: colorText === AntDesignWhite ? IconDarkMode : "",
                  }}
                />
                <Text>
                  {emptyTrip?.scheduleAt
                    ? dayjs(emptyTrip.scheduleAt).format("YYYY-MM-DD HH:mm:ss")
                    : emptyTrip?.estimatedDepartureTime
                    ? dayjs(emptyTrip.estimatedDepartureTime).format(
                        "YYYY-MM-DD HH:mm:ss",
                      )
                    : ""}
                </Text>
              </Space>
            </div>
          </Col>
          {emptyTrip?.userRequest?.country &&
            emptyTrip?.userRequest?.country.name !== "Uruguay" && (
              <Col>
                <div className="custom-text-card-trip">
                  <Space>
                    <Tag color="magenta">Internacional</Tag>
                    <Text>País: {emptyTrip?.userRequest?.country?.name}</Text>
                  </Space>
                </div>
              </Col>
            )}
          <Col span={24} style={{ textAlign: "right" }}>
            <Button
              size="small"
              icon={<MinusSquareOutlined />}
              type="primary"
              danger
              onClick={deleteEmptyTrip}
              disabled={deleting}
              loading={deleting}
            >
              Viaje vacio
            </Button>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default EmptyTripCard;
